import localStorageUtils from '../../../utils/local-storage';
const axios = require('axios');
export let source = axios.CancelToken.source();
let instance;

export const apiConfig = options => {
  if (source.token.reason && source.token.reason.message === 'canceled') {
    source = axios.CancelToken.source();
  }
  const { accessToken, selectedCompanyId, selectedDoctorId } = JSON.parse(localStorageUtils.getContext());

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
    'X-Company-ID': selectedCompanyId,
    'X-Doctor-ID': selectedDoctorId
  };
  if (selectedDoctorId) {
    headers['X-Logonas-ID'] = selectedDoctorId;
  }

  instance = axios.create({
    baseUrl: options.url,
    headers: headers,
    cancelToken: source.token
  });
  instance.CancelToken = axios.CancelToken;
  instance.isCancel = axios.isCancel;
  return instance;
};

export const send = options => {
  const api = apiConfig(options);
  return api(options);
};
